import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import MobileStickyBar, { WhatsAppFloat } from "./MobileStickyBar";
import { isTranslated, pageKeyFromSlug } from "../../data/localizedRoutes";
import { useI18n } from "../../i18n";

// Shared page shell: skip link, header, main content, footer, sticky elements.
export default function Layout({ children }) {
  const { lang, t } = useI18n();
  const { pathname } = useLocation();

  // Compute the English base path (strip language prefix), then map localized
  // slugs so the notice is hidden on fully-translated pages.
  let base = pathname;
  if (base === "/fr" || base.startsWith("/fr/")) base = base.slice(3) || "/";
  else if (base === "/de" || base.startsWith("/de/")) base = base.slice(3) || "/";
  if (base === "") base = "/";
  const seg = base.replace(/^\/|\/$/g, "");
  const key = pageKeyFromSlug(seg);
  const normalized = key === "doctorReview" ? "/__doctor-review__" : key === "aftercare" ? "/__aftercare__" : base;
  const showNotice = lang !== "en" && !isTranslated(normalized, lang);

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <a href="#main-content" className="skip-link">Skip to content</a>
      <Header />

      {showNotice && (
        <div className="bg-accent/15 border-b border-accent/25 font-sans" data-testid="translation-notice">
          <div className="container-psv py-2.5 text-center text-[13px] text-primary/80">
            {t("common.translationNotice")}
          </div>
        </div>
      )}

      <main id="main-content" className="flex-1">
        {children}
      </main>

      <Footer />
      <MobileStickyBar />
      <WhatsAppFloat />
      {/* Spacer so sticky mobile bar never covers footer content */}
      <div className="h-20 md:hidden" aria-hidden="true" />
    </div>
  );
}
